export default __webpack_public_path__ + "static/media/yelpCamp5.eac2a082.jpg";